import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./live.css";

export default function LiveChat({
  chat,
  onSendMessage,
  disabled,
  user,
}) {
  const [message, setMessage] = useState("");
  const chatEndRef = useRef(null);
  const inputRef = useRef(null);

  // Scroll automático para novas mensagens
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chat]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim() && !disabled) {
      onSendMessage(message.trim());
      setMessage("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <div className="live_chat">
      <div className="live_chat_header">
        <span>Chat ao vivo</span>
        <span className="chat_count">{chat?.length || 0} mensagens</span>
      </div>

      <div className="live_chat_messages">
        {chat?.length === 0 ? (
          <div className="chat_empty">
            <p>Seja o primeiro a comentar!</p>
          </div>
        ) : (
          chat?.map((msg, index) => (
            <div key={msg._id || index} className="chat_message">
              <Link
                to={`/profile/${msg.user?.username}`}
                className="chat_user_img"
              >
                <img src={msg.user?.picture} alt="" />
              </Link>
              <div className="chat_content">
                <Link
                  to={`/profile/${msg.user?.username}`}
                  className="chat_user_name"
                >
                  {msg.user?.first_name} {msg.user?.last_name}
                </Link>
                <span className="chat_text">{msg.message}</span>
              </div>
            </div>
          ))
        )}
        <div ref={chatEndRef} />
      </div>

      <form className="live_chat_input" onSubmit={handleSubmit}>
        <img src={user?.picture} alt="" className="chat_input_img" />
        <input
          ref={inputRef}
          type="text"
          placeholder={disabled ? "Chat desabilitado" : "Escreva um comentário..."}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={handleKeyPress}
          disabled={disabled}
          maxLength={500}
        />
        <button
          type="submit"
          disabled={disabled || !message.trim()}
          className="chat_send_btn"
        >
          <i className="fa fa-paper-plane"></i>
        </button>
      </form>
    </div>
  );
}
